<script setup lang="ts">
import { ETAPackage } from '@/models/reports';

export interface Props {
  packages: ETAPackage[];
}

defineProps<Props>();
</script>

<template>
  <section data-testid="etaReportTableFold" :class="$style.etaReportTableFold">
    <div
      v-for="(product, productIndex) in packages"
      :key="productIndex"
      :class="$style.package"
    >
      <h3>Package {{ productIndex + 1 }}</h3>
      <dl>
        <div>
          <dt>Description</dt>
          <dd>{{ product.pkg_description }}</dd>
        </div>
        <div>
          <dt>Id</dt>
          <dd>{{ product.pkg_id }}</dd>
        </div>
        <div>
          <dt>Serial</dt>
          <dd>{{ product.pkg_serial }}</dd>
        </div>
      </dl>
    </div>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.etaReportTableFold {
}
  .package {
    dl {
      display: flex;
      margin: 0 -1rem;
    }
      dl > div {
        margin: 0 1rem;
        width: 50%;
      }
      dt {
        margin: 0;
      }
      dd {
        font-weight: 500;
        margin: 0;
      }
  }
  .package:first-child {
    h3 {
      margin-top: 0;
    }
  }
</style>
